// import { Message } from 'element-ui';
// import { Toast } from 'vant'
import { device } from '@/utils/device'
import Vue from 'vue'

export function showMessage(message, type) {
  if (device.isMobile) {
    // Toast(message)
  } else {
    // Message({
    //   type: type,
    //   message: message
    // })
    let vue = new Vue()
    vue.$msgbox.toast(message, {type: type,dangerouslyUseHTMLString: true})
  }
}